import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-services-page',
  templateUrl: './services-page.component.html',
  styleUrls: ['./services-page.component.css']
})
export class ServicesPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

}
